
import { SalesCampaign ,
         SalesAction   }  from './types';


export const compareSalesAction = ( actionA: SalesAction , 
                                    actionB: SalesAction ): boolean => {
	
  const result = ( actionA.name               === actionB.name               ) && 
                 ( actionA.active             === actionB.active             ) &&
                 ( actionA.mediaId            === actionB.mediaId            ) &&
                 ( actionA.productId          === actionB.productId          ) && 
                 ( actionA.duration           === actionB.duration           ) && 
                 ( actionA.adPosition         === actionB.adPosition         ) && 
                 ( actionA.adWidth            === actionB.adWidth            ) && 
                 ( actionA.onlyQRcode         === actionB.onlyQRcode         ) && 
                 ( actionA.comment1           === actionB.comment1           ) && 
                 ( actionA.comment2           === actionB.comment2           ) && 
                 ( actionA.shapeColor1        === actionB.shapeColor1        ) && 
                 ( actionA.shapeColor2        === actionB.shapeColor2        ) && 
                 ( actionA.backgroundColor1   === actionB.backgroundColor1   ) && 
                 ( actionA.backgroundColor2   === actionB.backgroundColor2   ) && 
                 ( actionA.redirectionUuid    === actionB.redirectionUuid                ) && 
             //    ( actionA.alternateImageUrl  === actionB.alternateImageUrl  ) && 
                 ( actionA.alternateImageFile === actionB.alternateImageFile )  
              //   ( actionA.resultImageFile    === actionB.resultImageFile    )
		 
  return result
}

export const compareSalesCampaign = ( campaignA      : SalesCampaign  , 
                                      activeB        : boolean        , 
									  nameB          : string         , 
									  beginningDateB : Date | null    , 
									  endingDateB    : Date | null    , 
									  salesActionsB  : SalesAction [] ) : boolean => {

  let testSalesActionArray = campaignA.salesActions.length === salesActionsB.length

  if ( testSalesActionArray )
   {
    for ( let i=0 ; i < campaignA.salesActions.length ; i++ )
     {
	  testSalesActionArray = testSalesActionArray && compareSalesAction ( campaignA.salesActions[i] , salesActionsB[i] )
	  
	  if ( !testSalesActionArray )
	   {
		break;
	   }
	 }  
   }
	
  const result = ( campaignA.active        === activeB        ) && 
                 ( campaignA.name          === nameB          ) && 
                 ( campaignA.beginningDate === beginningDateB ) && 
                 ( campaignA.endingDate    === endingDateB    ) && testSalesActionArray
																		   
  console.log ("compareSalesCampaign 1", campaignA, activeB, nameB, beginningDateB, endingDateB, testSalesActionArray, result)
  console.log ("compareSalesCampaign 2", activeB, nameB, beginningDateB, endingDateB, salesActionsB )
  console.log ("compareSalesCampaign 3", testSalesActionArray, result)

  return result																			   
}
